import { FormControl, Grid, MenuItem, Select, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { Icon } from "../../../utils/MuiIcons/Icon";
import { vsprintf } from "sprintf-js";
import { replaceBracketPlaceholders } from "../utilities/replaceBracketPlaceholder";
import { baseURL } from "../../../api";
import { Global_Data } from "../../../globalData/GlobalData";
import { useSelector } from "react-redux";
import { setVarValue } from "../../../utils/store/action/varValueActions";

const CurrencyOption = ({
  data,
  selectedCurrency,
  setSelectedCurrency,
  currencyOptions,
  setCurrencyOptions,
  formAction,
  documentSelectTableData
}) => {
  const { component } = data || {};
  const { currency, sName } = component || {};
  const { token } = Global_Data();

  
    const varValueData = useSelector((state) => state.varValue?.data);

    useEffect(() => {
      if (!varValueData?.sCurrencyCode || currencyOptions.length === 0) return;

      const matched = currencyOptions.find(
        (item) => item.sCurrencyCode === varValueData.sCurrencyCode
      );

      if (matched) {
        const valueField = matched[currency?.sValueField];
        const rateField = Number(matched[currency?.dExchangeRateField]).toFixed(2);

        const newValue = `${valueField}:${rateField}`;

        console.log("Setting currency from Redux:", newValue);

        setSelectedCurrency(newValue);  
      }
    }, [varValueData?.sCurrencyCode, currencyOptions]);



  const handleChange = (e) => {
    setSelectedCurrency(e.target.value);
  };

  const fetchCurrencyOptions = async () => {
    try {
      const response = await fetch(
        `${baseURL}${data?.component?.currency?.sCurrencyDataSource}`,
        {
          method: "GET",
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const result = await response.json();
      setCurrencyOptions(result?.data?.records);

      if(formAction !== "EDIT" && documentSelectTableData?.length == 0){
        const defaultCurrency = result?.data?.records?.filter(
          (currItem) =>
            currItem?.sCurrencyCode == data?.component?.currency?.sDefaultValue,
        )?.[0];
        const valueField =
          defaultCurrency[data?.component?.currency?.sValueField];
        const rateField = Number(
          defaultCurrency[data?.component?.currency?.dExchangeRateField],
        ).toFixed(2);
        setSelectedCurrency(`${valueField}:${rateField}`);
      }
    } catch (error) {
      console.error("Error fetching currency options:", error);
    }
  };

  useEffect(() => {
    fetchCurrencyOptions();
  }, []);

  return (
    <Grid
      item
      xs={4}
      sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <Icon iconName={currency?.sIcon} dataSProps={currency?.sIconProps} />
        <Typography {...currency?.sLabelProps}>
          {currency?.sCurrencyCaption}
        </Typography>

        <FormControl {...currency?.sSelectProps}>
          <Select
            id={`${sName}-currency`}
            value={String(selectedCurrency)}
            onChange={handleChange}
            {...currency?.sSelectProps}
          >
            {currencyOptions.map((item, i) => {
              if (!item || Object.keys(item).length === 0) return null;

              const valueField = item[currency?.sValueField];
              const rateField = Number(
                item[currency?.dExchangeRateField],
              ).toFixed(2);

              const htmlContent = vsprintf(
                currency?.sDisplayFormat,
                replaceBracketPlaceholders(currency?.sDisplayField, item)
                  ?.replace(/[{}]/g, "")
                  ?.split(","),
              );

              return (
                <MenuItem
                  key={i}
                  value={`${valueField}:${rateField}`}
                  sx={{ whiteSpace: "pre-line" }}
                >
                  <div
                    style={{ width: "100%" }}
                    dangerouslySetInnerHTML={{ __html: htmlContent }}
                  />
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </div>
    </Grid>
  );
};

export default CurrencyOption;
